import createReducer from '../utils/createReducer';
import TravelerFeaturesRecord from '../records/travelerFeaturesRecord';
import actions from '../actions/travelerActions';

const initialState = new TravelerFeaturesRecord();

const actionHandlers = {
    [actions.USER_LOGGED_IN](state, {payload = {isLoggedIn: false}}) {
        return state.merge({
            isLoggedIn: payload.isLoggedIn
        });
    }
};

export default createReducer(actionHandlers, initialState);
